import { useState, useEffect } from "react";
import { FDWResultEntry } from "../../../restfd2/fdw_result";
import { useStore } from "../state/state";
import Checkbox from "./checkbox";
import { FundingsListAccordion } from "./fundings_list_accordion";
import { Tab } from "./tab";
import { H, ViewCopy } from "./view";

export function FundingsList(){
    const [active_tab, set_active_tab] = useState<"zuschusse" | "darlehen">("zuschusse");
    const [select_all, set_select_all] = useState(false);
    const include_in_print = useStore((state) => state.include_in_print);
    const set_include_in_print = useStore((state) => state.set_include_in_print);
    const fundings_list = useStore((state) => state.fundings_list);
    const questionizer_login = useStore((state) => state.questionizer_login);
    const questionizer_request_fundings = useStore((state) => state.questionizer_request_fundings);
    const questionizer_request_gid = useStore((state) => state.questionizer_request_gid);

    useEffect(()=>{
      async function load(){
        await questionizer_login();
        await questionizer_request_gid();
        await questionizer_request_fundings();
      }
      load();
    },[]);
    

    type SortedResultsList = Record<string,{region: string, list: Array<FDWResultEntry>}>;

    if (fundings_list == undefined){
      return <div></div>
    }
  
    const zuschuesse = fundings_list.filter((entry) => entry.fp_type == "Zuschuss").reduce((acc: SortedResultsList, entry : FDWResultEntry)=>{
      if (!acc[entry.region]){
        acc[entry.region] = {region:entry.region, list: [entry]}; 
      }else{
        acc[entry.region].list.push(entry);
      }
      return acc;
    },{});

    const darlehen = fundings_list.filter((entry) => entry.fp_type == "Darlehen").reduce((acc : SortedResultsList, entry : FDWResultEntry)=>{
      if (!acc[entry.region]){
        acc[entry.region] = {region:entry.region, list: [entry]}; 
      }else{
        acc[entry.region].list.push(entry);
      }
      return acc;
    },{});

    let zuschuesse_length = Object.keys(zuschuesse).flatMap(key => zuschuesse[key].list).length;
    let darlehen_length = Object.keys(darlehen).flatMap(key => darlehen[key].list).length;

    if (zuschuesse_length + darlehen_length == 0){
      return <></>
    }

    return <>
      <ViewCopy><H>Passende Förderprogramme</H></ViewCopy>
      <div role="select" className="tabs">
            <div className="tabs__header">
              <Tab label="Zuschüsse" value="zuschusse" count={zuschuesse_length} active_tab={active_tab} set_active_tab={set_active_tab}/>
              <Tab label="Darlehen" value="darlehen" count={darlehen_length} active_tab={active_tab} set_active_tab={set_active_tab}/>
            </div>
      
        <div className="tabs__header-b"> 
          <Checkbox value={select_all}  onChange={(value)=>{
            set_select_all(value);
            fundings_list.forEach((f) => {
            set_include_in_print(Number(f.fp_id), value);
            });
          }}/>
          <p className="mt-[0.5rem]">alle auswählen</p>
        </div>
      
            <div className="tabs__body">
              <FundingsListAccordion active={active_tab == "zuschusse"}  regions={zuschuesse} />
              <FundingsListAccordion active={active_tab == "darlehen"} regions={darlehen} />
            </div>
      </div>
    </>;  
  }